import axios from '@/axios-mock'

module.exports = {
  signature: (jsonData)=>{
    return axios({
      url: `/app/weixin/signature`,
      method: 'POST',
      json: jsonData
    })
  }
}



// WEBPACK FOOTER //
// ./static/wechat-share/api.js